import React from 'react'
import Tilt from 'react-tilt'
import '../assets/css/prizes_new.css'

function Prizes_new(props) {
    const prizes = props.prizes
    const prize = props.name === 'Aurora' ? ' ' : 'PRIZES'
  return (
      <>
    <h1>{prize}</h1>
    <div class="about-container poems">
        {
             Object.entries(prizes).map(([key,value]) => {
                return (
               
                    <Tilt style={{ backgroundColor: "transparent" , zIndex: "1" }}>
                        <div class="card-new">
                            <div class="content" style={{ backgroundColor: "transparent" , zIndex: "1" }}>
                                <h2 class="id">{value.id}</h2>
                                <h4 class="titles" style={{color : '#fff' , marginBottom:'50px'}}>{key}</h4>
                                <h5 class="openings" style={{color : '#fff'}}>{value.Award}</h5>
                            </div>
                        </div>
                    </Tilt>
               
                )
            })
        }

        {/* <Tilt style={{ backgroundColor: "transparent" , zIndex: "1" }}>
            <div class="card-new">
                <div class="content" style={{ backgroundColor: "transparent" , zIndex: "1" }}>
                    <h2 class="id">1</h2>
                    <h4 class="titles" style={{color : '#fff' , marginBottom:'50px'}}>Winner</h4>
                    <h5 class="openings" style={{color : '#fff'}}>Rs. 5,500 cash prize + Rs. 2,000 GeeksforGeeks discount coupons</h5>
                </div>
            </div>
        </Tilt>
        <Tilt style={{ backgroundColor: "transparent" , zIndex: "1" }}>
            <div class="card-new">
                <div class="content" style={{ backgroundColor: "transparent" , zIndex: "1" }}>
                    <h2 class="id">2</h2>
                    <h4 class="titles" style={{color : '#fff' , marginBottom:'50px'}}>First Runner Up </h4>
                    <h5 class="openings"  style={{color : '#fff'}}>Rs. 3,000 cash prize + Rs. 1,500 GeeksforGeeks discount coupons</h5>
                </div>
            </div>
        </Tilt>
        <Tilt style={{ backgroundColor: "transparent" , zIndex: "1" }}>
            <div class="card-new">
                <div class="content" style={{ backgroundColor: "transparent" , zIndex: "1" }}>
                    <h2 class="id">3</h2>
                    <h4 class="titles" style={{color : '#fff' , marginBottom:'50px'}}>Second Runner Up</h4>
                    <h5 class="openings" style={{color : '#fff'}}>Rs. 1,500 cash prize + Rs. 1,000 GeeksforGeeks discount coupons</h5>
                </div>
            </div>
        </Tilt> */}
    </div>
    </>
  )
}

export default Prizes_new